import { Link } from "react-router-dom";
import { categoryEntries } from "@/mocks/site";

const accentStyles: Record<string, { icon: string; chip: string; border: string }> = {
  primary: {
    icon: "bg-primary-100 text-primary-800",
    chip: "bg-primary-500 text-foreground-950",
    border: "hover:border-primary-300",
  },
  accent: {
    icon: "bg-accent-100 text-accent-800",
    chip: "bg-accent-500 text-background-50",
    border: "hover:border-accent-300",
  },
  secondary: {
    icon: "bg-secondary-100 text-secondary-800",
    chip: "bg-secondary-500 text-background-50",
    border: "hover:border-secondary-300",
  },
};

export default function CategoryGrid() {
  return (
    <div className="-mx-4 flex snap-x snap-mandatory gap-3 overflow-x-auto px-4 pb-2 no-scrollbar md:mx-0 md:grid md:grid-cols-3 md:gap-4 md:overflow-visible md:px-0 md:pb-0">
      {categoryEntries.map((entry) => {
        const styles = accentStyles[entry.accent];
        return (
          <Link
            key={entry.key}
            to={entry.to}
            className={`group flex min-w-[268px] snap-start flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors md:min-w-0 ${styles.border}`}
          >
            <div className="flex items-start justify-between">
              <span className={`flex h-11 w-11 items-center justify-center rounded-lg ${styles.icon}`}>
                <i className={`${entry.icon} text-xl`}></i>
              </span>
              <span className="flex h-8 w-8 items-center justify-center rounded-full border border-background-200 text-foreground-400 transition-colors group-hover:border-foreground-300 group-hover:text-foreground-800">
                <i className="ri-arrow-right-up-line text-base"></i>
              </span>
            </div>
            <h3 className="mt-4 font-heading text-lg text-foreground-950">{entry.title}</h3>
            <p className="mt-1 text-xs text-foreground-500">{entry.subtitle}</p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">{entry.description}</p>
            <span
              className={`mt-4 inline-flex w-fit items-center gap-1 rounded-full px-2.5 py-1 text-[11px] font-medium ${styles.chip}`}
            >
              立即浏览
              <i className="ri-arrow-right-line text-xs"></i>
            </span>
          </Link>
        );
      })}
    </div>
  );
}